// This plugin only affects Modernizr "no-touch" devices. Any element with class="fadeIn" will have its opacity set to 0 on document.ready, and opacity is animated to 1.0 only after the user has scrolled the element into view.

/*

<div class="fadeIn" data-fadespeed="2000" data-fadedelay="200">
	<p>Fade me in over 2000ms, but only after waiting 200ms</p>
</div>

*/

$(document).ready(function(){

	if ($('html').hasClass('no-touch')) {

		var windowH = $(window).height();
		var faders = $('.fadeIn');

		faders.each(function(){
			var cur = $(this);
			cur.addClass('init-fade-in');
			cur.css('opacity', '0');
			checkFade(cur);
		});
	
		$(window).scroll(function() {
			$.data(this, 'scrollFadeTimer', setTimeout(function() {
				faders.each(function(){
					checkFade($(this));
				});
			}, 50));
		});
	}
	
	function checkFade(el) {
		var scrollTop = $(window).scrollTop();
	
		var speed = 500;
		var delay = 0;
	
		if (el.data('fadespeed')) {
			speed = parseInt(el.data('fadespeed'));
		}
	
		if (el.data('fadedelay')) {
			delay = parseInt(el.data('fadedelay'));
		}
	
		if (el.hasClass('fade-done') == false && scrollTop + windowH > el.offset().top) {
			setTimeout(function(){
				el.animate({
					opacity: 1.0
				}, speed);
		
				el.addClass('fade-done');
			}, delay);
		
		}
	}
});